export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE';
export const ADD_QUESTION = 'ADD_QUESTION';
export const REMOVE_QUESTION = 'REMOVE_QUESTION';
export const REMOVE_FORM_ERRORS = 'REMOVE_QUESTION_ERRORS';
export const UPDATE_QUESTION = 'UPDATE_QUESTION';
export const DUPLICATE_LAST_QUESTION = 'DUPLICATE_LAST_QUESTION';
export const SET_ACTIVE_QUESTION = 'SET_ACTIVE_QUESTION';
export const ADD_QUESTION_OPTION = 'ADD_QUESTION_OPTION';
export const REMOVE_QUESTION_OPTION = 'REMOVE_QUESTION_OPTION';
export const UPDATE_QUESTION_OPTION = 'UPDATE_QUESTION_OPTION';
export const SET_QUESTION_OPTION_ERRORS = 'SET_QUESTION_OPTION_ERRORS';
export const RESET_STATE = 'RESET_STATE';
export const SWITCH_QUESTION_ORDER = 'SWITCH_ORDER';
export const CLONE_QUESTION = 'CLONE_QUESTION';
export const REORDER_QUESTION_OPTIONS = 'REORDER_QUESTION_OPTIONS';

export const resetState = () => ({
  type: RESET_STATE,
  payload: {}
});

export const setQuestionOptionErrors = (payload) => ({
  type: SET_QUESTION_OPTION_ERRORS,
  payload: { ...payload }
});

export const setActiveQuestion = (id) => ({
  type: SET_ACTIVE_QUESTION,
  payload: { id }
});

export const addQuestion = (newQuestion = {}) => ({
  type: ADD_QUESTION,
  payload: { ...newQuestion }
});

export const cloneQuestion = (id) => ({
  type: CLONE_QUESTION,
  payload: { id }
});

export const removeQuestion = (id) => ({
  type: REMOVE_QUESTION,
  payload: { id }
});

export const removeFormErrors = () => ({
  type: REMOVE_FORM_ERRORS,
  payload: {}
});

export const updateQuestion = (question = {}) => ({
  type: UPDATE_QUESTION,
  payload: { ...question }
});

export const switchQuestionOrder = (payload) => ({
  type: SWITCH_QUESTION_ORDER,
  payload: { ...payload }
});

export const updateTemplate = (payload = {}) => ({
  type: UPDATE_TEMPLATE,
  payload: { ...payload }
});

export const duplicateLastQuestion = () => ({
  type: DUPLICATE_LAST_QUESTION,
  payload: {}
});

export const addQuestionOption = (questionOption = {}) => ({
  type: ADD_QUESTION_OPTION,
  payload: { ...questionOption }
});

export const removeQuestionOption = (questionOption = {}) => ({
  type: REMOVE_QUESTION_OPTION,
  payload: { ...questionOption }
});

export const updateQuestionOption = (questionOption = {}) => ({
  type: UPDATE_QUESTION_OPTION,
  payload: { ...questionOption }
});

export const reorderQuestionOptions = (payload) => ({
  type: REORDER_QUESTION_OPTIONS,
  payload
});
